/**
 * GraphQL の変数から、Sentry に載せてよい情報だけを残す。
 *
 * このアプリの変数には従業員の氏名・メールアドレスが載る（関係性の入稿、候補者の一括登録、
 * リマインドメールの宛先など）。列挙して塞ぐ方式では新しい操作を足すたびに漏れるため、
 * **既定は伏せる**方針にして、調査に必要な識別子と数量だけを通す。
 */

const ID_KEY_PATTERN = /(^id$|Id$|Ids$)/;

const REDACTED_STRING = "<string>";

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function redactValue(key: string, value: unknown): unknown {
  if (value === null || value === undefined) return value;
  // 数値・真偽値は個人を特定しないので、そのまま調査に使える
  if (typeof value === "number" || typeof value === "boolean") return value;
  if (typeof value === "string") {
    return ID_KEY_PATTERN.test(key) ? value : REDACTED_STRING;
  }
  if (Array.isArray(value)) {
    // 中身は伏せるが、何件送ったかは原因の切り分けに効く
    return `<array:${value.length}>`;
  }
  if (isPlainObject(value)) return redactObject(value);
  return REDACTED_STRING;
}

function redactObject(value: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(value).map(([key, child]) => [key, redactValue(key, child)]),
  );
}

export function redactVariables(variables: unknown): Record<string, unknown> {
  if (!isPlainObject(variables)) return {};
  return redactObject(variables);
}
